<template>
  <div class="index requests-wrapper">
    <el-tabs v-model="active">
      <el-tab-pane label="Заявки на обслуживание" name="first">
        <div class="requests">
          <div class="tr columns">
            <span class="empty"></span>
            <span class="column">Имя</span>
            <span class="column">Контакты</span>
            <span class="column">ИНН</span>
            <span class="column">Прикрепленный документ</span>
            <span class="column">Статус клиента</span>
            <span class="column">Дата заявки</span>
          </div>
          <RequestItem v-for="request in requestsObject" :request="request" :key="request.id" />
        </div>
      </el-tab-pane>
      <el-tab-pane label="Заявки на консультацию" class="consultation-requests">
        <div class="tr columns">
          <span class="empty"></span>
          <span class="column">Имя</span>
          <span class="column">Контакты</span>
          <span class="column">Время консультации</span>
          <span class="column">Статус клиента</span>
          <span class="column">Дата заявки</span>
        </div>
        <ConsultationRequestItem v-for="request in consultationRequestsObject" :request="request" :key="request.id" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import deepcopy from 'deepcopy'
import RequestItem from 'components/ServiceRequests/ServiceRequestItem'
import ConsultationRequestItem from 'components/ServiceRequests/ConsultationRequestItem'

export default {
  name: 'ServiceRequests',
  data () {
    return {
      active: 'first'
    }
  },
  computed: {
    ...mapState(['serviceRequests', 'consultationRequests']),
    requestsObject () {
      return deepcopy(this.serviceRequests)
    },
    consultationRequestsObject () {
      return deepcopy(this.consultationRequests)
    }
  },
  created () {
    this.getServiceRequests()
  },
  methods: {
    ...mapActions(['getServiceRequests'])
  },
  components: { RequestItem, ConsultationRequestItem }
}
</script>

<style scoped>
@import "../../global.css";
.requests,
.tr.columns {
  min-width: 800px;
}
.requests {
  max-width: 1368px;
  margin: -10px auto;
}
.tr .column {
  display: inline-block !important;
}
.tr.columns span {
  padding: 15px;
  min-width: 15%;
}
.tr.columns {
  margin: 10px 5px;
}
.empty {
  min-width: 55px !important;
}
.consultation-requests {
  max-width: 1150px;
  margin: 0 auto;
}
</style>
<style>
.requests-wrapper .el-tabs__active-bar {
  background: none !important;
}
.requests-wrapper .el-tabs__nav {
  text-align: center;
  float: initial;
}
</style>



// WEBPACK FOOTER //
// Index.vue?6e1489c1